import React, { Component } from "react";
import { HtmlBook } from "./HtmlBook";

export class HtmlFrame extends Component {
  // state = {
  //   htmlString: compare()
  // };

  //  const nav_links=[{id:1,name:"Possesive pronuns"},{id:2,name:"Adjective comparisons"},{id:3,name:"Demostrative pronuns"}]
  //   clickLinks = Name => {
  //     let temp = "";
  //     if (Name == 1) temp = s_possesive();
  //     if (Name == 2) temp = compare();
  //     if (Name == 3) temp = demostrative();
  //     if (Name == 4) temp = s_conditional();
  //     if (Name == 5) temp = f_en_and_y();
  //     if (Name == 6) temp = f_bien_bon();
  //     if (Name == 7) temp = f_mieux_meilleur();

  //     this.setState({
  //       htmlString: temp
  //     });
  //   };
  //    {/* <div dangerouslySetInnerHTML={{ __html: HtmlBook() }} />  */}
  render() {
    return (
      <div>
        <div class="myClass">Hello</div>
        <div class="myClass">Hello</div>
        <div class="myClass">Hello</div>
      </div>
    );
  }
}

export default HtmlFrame;
